module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.44b78f1.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Thin.woff
// module id = 456
// module chunks = 1